import { render } from "./EventContent.vue?vue&type=template&id=164e80a0&scoped=true"
import script from "./EventContent.vue?vue&type=script&lang=js"
export * from "./EventContent.vue?vue&type=script&lang=js"

import "./EventContent.vue?vue&type=style&index=0&id=164e80a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164e80a0"]])

export default __exports__